import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";
import MentionComposer from "../../components/pm/MentionComposer";

const msg = (e) => e?.response?.data?.detail?.message || "Could not load threads.";

// B7: project-wide message threads; @mentions notify the mentioned team member in-app.
export default function ProjectThreads() {
  const { pid } = useParams();
  const [threads, setThreads] = useState([]);
  const [team, setTeam] = useState([]);
  const [open, setOpen] = useState(null);
  const [note, setNote] = useState("");
  const load = useCallback(() => api.get(`/pm/projects/${pid}/threads`).then((r) => setThreads(r.data)).catch((e) => setNote(msg(e))), [pid]);
  useEffect(() => { load(); api.get(`/pm/projects/${pid}/team`).then((r) => setTeam(r.data)).catch(() => setTeam([])); }, [load, pid]);
  const view = (id) => api.get(`/pm/threads/${id}`).then((r) => setOpen(r.data)).catch((e) => setNote(msg(e)));
  const start = (v) => api.post(`/pm/projects/${pid}/threads`, v).then((r) => { setOpen(r.data); return load(); });
  const reply = (v) => api.post(`/pm/threads/${open.id}/messages`, v).then(() => view(open.id));
  return (
    <AppShell title="Project threads" subtitle="Team conversations on this project">
      <div className="mx-auto w-full max-w-[900px] px-4 md:px-6 grid gap-6 md:grid-cols-[280px_1fr]" data-testid="pm-threads">
        {note && <p role="alert" className="text-sm text-red-700 md:col-span-2" data-testid="pm-threads-error">{note}</p>}
        <div className="space-y-3">
          <ul className="space-y-1">{threads.map((t) => (
            <li key={t.id}><button type="button" onClick={() => view(t.id)} className="w-full text-left min-h-[44px] px-3 rounded border border-erf-borderCream bg-white text-sm hover:bg-erf-creamSecondary"
              data-testid={`pm-thread-${t.id}`}>{t.title} <span className="text-xs text-erf-dark/60">({t.message_count})</span></button></li>))}
          </ul>
          {!threads.length && <p className="text-sm" data-testid="pm-threads-empty">No threads yet.</p>}
          <MentionComposer team={team} withTitle onSend={start} testPrefix="pm-new-thread" />
        </div>
        {open && (
          <section className="space-y-3" data-testid="pm-thread-open">
            <h2 className="font-heading text-lg">{open.title}</h2>
            <ul className="space-y-2">{open.messages.map((m) => (
              <li key={m.id} className="border border-erf-borderCream rounded bg-white p-3 text-sm" data-testid={`pm-msg-${m.id}`}>
                <span className="font-semibold">{m.author_name}</span> <span className="text-xs text-erf-dark/60">{m.created_at.slice(0, 16).replace("T", " ")}</span>
                <p className="whitespace-pre-wrap break-words">{m.body}</p>
              </li>))}
            </ul>
            <MentionComposer team={team} onSend={reply} testPrefix="pm-reply" />
          </section>
        )}
      </div>
    </AppShell>
  );
}
